import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let surveyOptions = [];
let companyProductOptions = [];
function SurveyProductTableRow({ index, productList, surveyList, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [companyProductKey, setCompanyProductKey] = useState(0);
	const [companyProductSelected, setCompanyProductSelected] = useState({ name: "companyProductKey", label: "", value: 0 });
	const [companyProductLoaded, setCompanyProductLoaded] = useState(false);
	const [surveyKey, setSurveyKey] = useState(0);
	const [surveySelected, setSurveySelected] = useState({ name: "surveyKey", label: "", value: 0 });
	const [surveyLoaded, setSurveyLoaded] = useState(false);
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		setProductValues(productList);
		setSurveyValues(surveyList);
	}, []);
	
	function setSurveyValues(surveyList) {
		let surveyValue = {};
		surveyOptions = [];
		surveyOptions.push({ label: "", value: 0 });
		if (surveyList && surveyList.length > 0) {
			surveyList.map((aSurvey) => {
				surveyValue.label = aSurvey.surveyDisplayName;
				surveyValue.value = aSurvey.surveyKey;
				surveyOptions.push(surveyValue);
				surveyValue = {};
			});
		}
		setSurveyLoaded(true);
		setSurveySelected({ ...surveySelected, label: "", value: 0 });
	}
	function setProductValues(productList) {
		let companyProductValue = {};
		companyProductOptions = [];
		companyProductOptions.push({ label: "", value: 0 });
		if (productList && productList.length > 0) {
			productList.map((aProduct) => {
				companyProductValue.label = aProduct.productName + "-" +aProduct.productSku;
				companyProductValue.value = aProduct.companyProductKey;
				companyProductOptions.push(companyProductValue);
				companyProductValue = {};
			});
		}
		setCompanyProductLoaded(true);
		setCompanyProductSelected({ ...companyProductSelected, label: "", value: 0 });
	}

	const companyProductHandler = (selectedOption, action) => {
		let selectedCompanyProductKey = selectedOption ? selectedOption.value : 0;
		let selectedProductName = selectedOption ? selectedOption.label : "";
		setCompanyProductKey(selectedCompanyProductKey);
		setCompanyProductSelected({ ...companyProductSelected, label: selectedProductName, value: selectedCompanyProductKey });
	}

	const surveyHandler = (selectedOption, action) => {
		let selectedSurveyKey = selectedOption ? selectedOption.value : 0;
		let selectedSurveyName = selectedOption ? selectedOption.label : "";
		setSurveyKey(selectedSurveyKey);
		setSurveySelected({ ...surveySelected, label: selectedSurveyName, value: selectedSurveyKey });
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);

		if (!companyProductKey || companyProductKey === 0) {
			setError(t("error.prod.Reqd"));
			setIsSubmit(false);
		} else if (!surveyKey || surveyKey === 0) {
			setError(t("error.survey.Reqd"));
			setIsSubmit(false);
		} else {
			let initialValues = {
				companyProductKey: companyProductKey,
				surveyKey: surveyKey,
			};
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
			{surveyLoaded ? <Select
				name="surveyKey"
				options={surveyOptions}
				onChange={surveyHandler}
				placeholder={""}
				value={surveySelected}
				isSearchable={true}
				isClearable={true}
				className="myselect"
				inputId="surveyKey-input"
				styles={ddStyles}
			/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{companyProductLoaded ? <Select
					name="companyProductKey"
					options={companyProductOptions}
					onChange={companyProductHandler}
					placeholder={""}
					value={companyProductSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="companyProductKey-input"
					styles={ddStyles}
				/>
					: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default SurveyProductTableRow;